export default "__VITE_ASSET__RCvmO180__"